import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const VisualHeatIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M15.25,6.84C15.25,5,11.76,2,7.79,2S.33,5.26.33,6.84c0,1.8,3.61,4.79,7.46,4.79S15.25,8.37,15.25,6.84ZM7.65,8.22A1.34,1.34,0,1,1,9,6.88,1.34,1.34,0,0,1,7.65,8.22Zm.78,1.62a3.09,3.09,0,1,0-1.63,0C4.1,9.39,2.15,7.37,2.05,6.88c.14-.65,2.57-3.11,5.74-3.11s5.58,2.37,5.72,3A7.34,7.34,0,0,1,8.43,9.84Z" />
      <path d="M22.35,7.64l-.07-.09,0,0a2.73,2.73,0,0,0-2.45-.73,5.91,5.91,0,0,0-3,1.45c-1.68,1.46-2.41,3.43-1.82,4.83a2.42,2.42,0,0,1-.74.28,2.45,2.45,0,0,0-1.66,1.07,5.41,5.41,0,0,0-.61,3,3.76,3.76,0,0,1-.07,1c-.25.58-.45.62-1.09.71a3.11,3.11,0,0,0-2.12,1.09.89.89,0,0,0,.12,1.25.87.87,0,0,0,.55.2.9.9,0,0,0,.68-.32,1.37,1.37,0,0,1,1-.46h0a2.7,2.7,0,0,0,2.41-1.77,4.42,4.42,0,0,0,.21-1.69,3.93,3.93,0,0,1,.36-2c.07-.12.18-.17.64-.3a3.63,3.63,0,0,0,1.54-.76,3.22,3.22,0,0,0,1.72.13A6.13,6.13,0,0,0,20.88,13a6.1,6.1,0,0,0,1.82-2.62A2.78,2.78,0,0,0,22.35,7.64ZM21,9.77a4.51,4.51,0,0,1-1.27,1.7,4.26,4.26,0,0,1-2,1c-.29,0-.8.08-1-.19-.39-.47.08-1.84,1.29-2.9a4,4,0,0,1,2.36-1.06.93.93,0,0,1,.65.22c.26.32.06.94,0,1.06L21,9.77Z" />
    </SvgIcon>
  )
}
export default VisualHeatIcon
